import { Injectable } from "@angular/core";

export function initAppConfigService(appConfig: AppConfigService, data: any) {
  return () => {
    return appConfig.initAppConfig(data);
  };
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private appConfig;

  get environmentName(): string {
    return this.appConfig.environment ?? '';
  }

  get isTestEnvironment(): boolean {
    return this.appConfig.testEnvironment;
  }

  initAppConfig(data: any) {
    return new Promise<void>(resolve => {
        this.appConfig = data;
        resolve();
      });
  }

  getConfig() {
    const config = JSON.parse(JSON.stringify(this.appConfig));

    if (!config.baseUrl) {
      if (!window.location.port) {
        config.baseUrl = `${window.location.protocol}//${window.location.hostname}`;
      } else {
        config.baseUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
      }
    }

    if ((window.location.hostname !== 'localhost'
      && !config.apiUrl.includes('localhost')) // ToRemove
      && !config.apiUrlComplete
    ) {
      config.apiUrl = `${window.location.protocol}//${window.location.hostname}${config.apiUrl}`;
    }

    return config;
  }

}
